module.exports = __webpack_public_path__ + "img/icon_calculator.2e5a5dbe.svg";